export default __webpack_public_path__ + "static/media/heart.c00da432.svg";